export default {
    label: 'Please select the service.',
    heading: 'Change of service',
    maintenance: 'Arranging service',
    tires: 'Tires',
    callingAction: 'Recall',
    chargingStation: 'Charging stations'
}
